import type { ReactNode } from "react";
import { ThemeToggle } from "./ThemeToggle";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div
      data-page-header
      className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between"
    >
      {/* min-w-0 mais flex-1: sem eles um titulo longo empurra as acoes para
          fora da tela em vez de quebrar. */}
      <div className="min-w-0 flex-1">
        <h1 className="text-h4 font-black tracking-tight sm:text-h3">{title}</h1>
        {description ? (
          <p className="mt-1 text-small text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-2">
        {actions}
        <div className="hidden lg:block">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
